export default __webpack_public_path__ + "static/media/redInfo.f12546dd.svg";